import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconOpen(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14c0 1.1-.9 2-2 2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2V5H5v14h2c.55 0 1 .45 1 1s-.45 1-1 1H5c-1.1 0-2-.9-2-2V5Zm9.707 4.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L11 12.414V20a1 1 0 1 0 2 0v-7.586l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
